export var divider = {
  keyCommand: 'divider'
};
//# sourceMappingURL=divider.js.map